import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiItemsListFilterComponent } from './fi-items-list-filter/fi-items-list-filter.component';
import { FiItemsListFilterService } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter.service';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FormsModule } from '@angular/forms';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { FiMenuItemSearchModule } from '@fi-shared/fi-menu-item-search/fi-menu-item-search.module';
import { FiMenuMultiSelectItemSearchModule } from '@fi-shared/fi-menu-multi-select-item-search/fi-menu-multi-select-item-search.module';
import { FiDatePickerModule } from '@fi-shared/fi-date-picker';
import { FiItemsListFilterHeaderComponent } from './fi-items-list-filter/fi-items-list-filter-header/fi-items-list-filter-header.component';
import { FiItemsListFilterSettingsDetailsComponent } from './fi-items-list-filter/fi-items-list-filter-settings-details/fi-items-list-filter-settings-details.component';
import { FiFilterSettingsSummaryComponent } from './fi-items-list-filter/fi-items-list-filter-settings-details/fi-filter-settings-summary/fi-filter-settings-summary.component';
import { FiFilterSettingsActionsComponent } from './fi-items-list-filter/fi-items-list-filter-settings-details/fi-filter-settings-actions/fi-filter-settings-actions.component';
import { FiFilterSettingsMenusComponent } from './fi-items-list-filter/fi-items-list-filter-settings-details/fi-filter-settings-menus/fi-filter-settings-menus.component';
import { FiItemsListSaveFilterDialogComponent } from './fi-items-list-filter/fi-items-list-save-filter-dialog/fi-items-list-save-filter-dialog.component';
import { MatInputModule } from '@angular/material/input';
import { FiItemsListEditFilterDialogComponent } from './fi-items-list-filter/fi-items-list-edit-filter-dialog/fi-items-list-edit-filter-dialog.component';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiItemsListFilterHelperService } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter-helper.service';
import { FiFilterSavedFiltersMenuComponent } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter/fi-filter-saved-filters-menu/fi-filter-saved-filters-menu.component';
import { FiMenuFoldableMultiSelectItemSearchModule } from '@fi-shared/fi-menu-foldable-multi-select-item-search/fi-menu-foldable-multi-select-item-search.module';
import { ItemsListFilterSelectionMapperService } from './services/items-list-filter-selection-mapper.service';
import { ItemsListFilterDialogSnackbarService } from './services/items-list-filter-dialog-snackbar.service';

@NgModule({
    imports: [
        CommonModule,
        FiLoadingModule,
        FormsModule,
        SelectSearchModule,
        FiAppTextSharedModule,
        MatIconModule,
        FiToggleSwitchModule,
        MatButtonModule,
        MatMenuModule,
        MatCheckboxModule,
        MatListModule,
        FiMenuItemSearchModule,
        FiMenuMultiSelectItemSearchModule,
        FiDatePickerModule,
        MatInputModule,
        InfoIconModule,
        FiMenuFoldableMultiSelectItemSearchModule,
    ],
    declarations: [
        FiItemsListFilterComponent,
        FiItemsListFilterHeaderComponent,
        FiItemsListFilterSettingsDetailsComponent,
        FiFilterSettingsSummaryComponent,
        FiFilterSettingsActionsComponent,
        FiFilterSettingsMenusComponent,
        FiItemsListSaveFilterDialogComponent,
        FiItemsListEditFilterDialogComponent,
        FiFilterSavedFiltersMenuComponent,
    ],
    exports: [FiItemsListFilterComponent, FiFilterSettingsActionsComponent, FiFilterSavedFiltersMenuComponent],
    providers: [FiItemsListFilterService, FiItemsListFilterHelperService, ItemsListFilterSelectionMapperService, ItemsListFilterDialogSnackbarService],
})
export class FiItemsListFilterModule {}
